import { Patient } from '@bioliberty/lifemind';
import { PaginationState, Row, SortingState } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { usePatientTableColumns } from '../hooks/usePatientTableColumns';

interface PatientDataTableProps {
  patients: Patient[];
  loading: boolean;
  initialSorting?: SortingState;
  pageCount: number;
  pageSize: number;
  onSortingChange?: (sorting?: SortingState) => void;
  onPaginationChange?: (pagination?: PaginationState) => void;
}

export const PatientDataTable = ({
  patients,
  loading,
  initialSorting,
  pageCount,
  pageSize,
  onSortingChange,
  onPaginationChange
}: PatientDataTableProps) => {
  const navigate = useNavigate();
  const columnDefinitions = usePatientTableColumns();

  return (
    <DataTable
      rows={patients}
      columns={columnDefinitions}
      initialSorting={initialSorting}
      manualSorting={true}
      onSortingChange={onSortingChange}
      pageCount={pageCount}
      pageSize={pageSize}
      onPaginationChange={onPaginationChange}
      isLoading={loading}
      onRowClick={(row: Row<Patient>) => navigate(`/patients/${row.original.id}`)}
      stickyHeader
      testId="patients-list"
      className="mt-4 min-w-[600px]"
    />
  );
};
